import React from 'react';
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
  Chip
} from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

const HierarchyBreadcrumbs = ({ 
  runId, 
  hierarchyId, 
  hierarchyName, 
  navigationPath = [], 
  onNavigate 
}) => {
  const handleBreadcrumbClick = (type, id, name) => {
    if (onNavigate) {
      onNavigate(type, id, name);
    }
  };

  const breadcrumbItems = [
    {
      type: 'run',
      id: runId,
      name: `Run: ${runId}`,
      label: runId
    },
    {
      type: 'hierarchy',
      id: hierarchyId,
      name: hierarchyName,
      label: hierarchyName
    },
    ...navigationPath.map((item, index) => ({
      type: item.type,
      id: item.id,
      name: item.name,
      label: item.name,
      isLast: index === navigationPath.length - 1
    }))
  ];

  return (
    <Box sx={{ mb: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="Hierarchy navigation"
      >
        {breadcrumbItems.map((item, index) => {
          const isLast = index === breadcrumbItems.length - 1;
          
          if (isLast) {
            return (
              <Typography 
                key={`${item.type}-${item.id}`}
                color="text.primary"
                sx={{ fontWeight: 'medium' }}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={`${item.type}-${item.id}`}
              color="inherit"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleBreadcrumbClick(item.type, item.id, item.name);
              }}
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default HierarchyBreadcrumbs; 